var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2507 11.3527C6.02236 11.5809 5.7127 11.7092 5.38981 11.7092C5.06693 11.7092 4.75727 11.5809 4.52892 11.3527L0.696526 7.51702C0.250531 7.07071 0 6.46557 0 5.83461C0 5.20366 0.250531 4.59852 0.696526 4.15221L4.53217 0.316562C4.76387 0.105984 5.06777 -0.0072552 5.38077 0.000360683C5.69376 0.00797657 5.9918 0.135863 6.21298 0.357459C6.43416 0.579056 6.56148 0.877333 6.56851 1.19034C6.57553 1.50335 6.46172 1.80704 6.2507 2.03834L3.62623 4.60924H15.164C16.3089 4.61031 17.4066 5.06555 18.2163 5.87504C19.0259 6.68454 19.4814 7.78217 19.4827 8.92708V14.3506C19.4816 15.4952 19.0264 16.5926 18.2171 17.402C17.4077 18.2113 16.3103 18.6665 15.1656 18.6676H4.31705C3.99411 18.6676 3.68439 18.5393 3.45603 18.3109C3.22767 18.0826 3.09939 17.7729 3.09939 17.4499C3.09939 17.127 3.22767 16.8173 3.45603 16.5889C3.68439 16.3605 3.99411 16.2323 4.31705 16.2323H15.1648C15.6638 16.2318 16.1423 16.0335 16.4952 15.6807C16.8481 15.3279 17.0467 14.8496 17.0473 14.3506V8.92708C17.0469 8.4278 16.8483 7.9491 16.4952 7.59613C16.1421 7.24316 15.6633 7.04478 15.164 7.04457H3.67088L6.2507 9.63089C6.47898 9.85923 6.60722 10.1689 6.60722 10.4918C6.60722 10.8147 6.47898 11.1243 6.2507 11.3527Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undoIcon.62928729271e293073d9c78a12aa2551.svg";
export { ForwardRef as ReactComponent };